export default __webpack_public_path__ + "static/media/trust-logo.b974e5fc.png";